module.exports = __webpack_public_path__ + "img/star-wars-dark-small.09f5c2a7.svg";